import { getConfig } from '@atlassian/atlassian-studio-common';

export const redirectToLogin = () => {
	const href = window.location.href;
	const loginUrl = `${getConfig().atlassianAccountUrl}/login?continue=${encodeURIComponent(href)}`;
	window.location.href = loginUrl;
};
